<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h4 class="h no-margin-bottom">Cihaz Düzenle Müşteri : {{cariad}}</h4>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/defines/cihazgrup"><button type="submit" class="btn submit bg-dark text-light mr-w">Ana Gruplar</button>
          </router-link>
          <router-link to="/liste/cihaz"><button type="submit" class="btn submit bg-dark text-light">Alt Gruplar</button>
          </router-link>
          <router-link :to="`/detay/cihaz/${newPost.id*8589}`"><button type="submit" class="btn submit bg-dark text-light">Geri Dön</button>
          </router-link>
       </div>
      </div>
    </div>

  <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
          <div class="block" >
            <div class="block-body">
             <div class="form-group">
              <div class="row">
                <div class="col-lg-3 col-12">
                   <label class="form-control-label">Sağlayıcı</label>
                   <select v-model="newPost.sa" class="form-control">
                    <option value="0">Sağlayıcı Yok</option>
                    <option v-for="(option,index) in sa" :value="option.id" :key="index">{{ option.alias }}</option>
                   </select>
                </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Barkod</label>
                <input placeholder="Min 6 karakter" type="text" class="form-control" v-model="newPost.barkod"/>  
              </div>                        
              <div class="col-lg-3 col-12">
                <label class="form-control-label">Cihaz Anagrup</label>
                <select v-model="grupid" @change="onChange($event)" class="form-control">
                  <option value="0">Cihaz Grubunu seç</option>
                  <option v-for="option in grup" :value="option.id" :key="option.id">{{ option.alias }}
                  </option>
                </select>
              </div>
              <div class="col-lg-3 col-12">
                <label class="form-control-label">Model</label>
                <select v-model="newPost.kat" class="form-control">
                  <option v-for="option in altgrup" :value="option.id" :key="option.id">{{ option.alias }}</option>
                </select> 
              </div>
              
            </div>
            <div class="row mt-4">
              <div class="col-lg-3 col-12">
                <label class="form-control-label">Aktiflik Tarihi({{$helper.trtgoster(newPost.tarih)}})</label>
                <input class="form-control" v-model="newPost.tarih" type="date">
              </div>
              <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Durumu</label>
                <select v-model="newPost.durum" class="form-control">
                  <option value="0">Cihaz Durumu</option>
                  <option v-for="(tip,index) in cdler" :value="tip.id"  :key="index">{{ tip.alias }}</option>
                </select> 
              </div>

              <div class="col-lg-3 col-12 p-2">
                <button @click="tipsec()" class="btn btn-dark mt-4 w-100">Müşteri Değiştir</button>
              </div>

              <div class="col-lg-3 col-12 mt-4 p-2">
                <button @click="sendNewPost()" class="btn btn-danger w-100">{{progres.mesaj}}</button>
              </div>
            </div>
            
          </div>
        </div>
      </div>
              <div v-if="cariSec"  class="row">
                <div class="col-12" >
                <input class="form-control" placeholder="Cari Arama" id="arama" type="text" @keyup="this.$helper.tabloarama"/>
                <div class="block margin-bottom-sm">
                  <div class="table-responsive"> 
                    <table id="tablo" class="table">
                      <thead>
                        <tr>
                          <th>Kodu</th>
                          <th>Cari</th>
                          <th>Konum</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr @click="calistir(caris.kodu,caris.alias,caris.id)"  v-for="caris in cari" :key="caris.id" :class="{highlight:caris.id == selected}" >
                          <td>{{caris.kodu}}</td>
                          <td>{{caris.alias}}</td>
                          <td>{{caris.il +' '+ caris.ilce}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                </div>
              </div>      
            <div class="row">
              <div class="col-12">
                <div class="footer__block block no-margin-bottom">
                  <div v-if="errors && errors.length" class="container-fluid text-center">
                    <div class="loading dashtext-2">Veritabanı Hatası</div>
                     <ul>
                        <li v-for="(error, index) of errors" :key="index">
                          {{ index + 1 }} - {{ error.message }}
                        </li>
                      </ul>
                  </div>
                </div>
              </div>
            </div>      
    </div>
  </section>
  <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
</div>
</template>
<script>

  export default {
computed:{
    filteredList() {
      return this.posts.filter(post => {
        return post.barkod.toLowerCase().includes(this.newPost.barkod.toLowerCase())
      })
    }    
    },    
    created() {
      this.cdgetir('cd')
      this.yetki();
      this.sagetir();
      this.cihazgrup();
    },
    data() {
      return {
        progres : {
        mesaj:'Bekleyiniz',
        inprogres:true
      },
        cariSec : false,
        table : 'cihaz',
        posts: [],
        cdler : [],
        errors: [],
        cari : [],
        selected : '',
        grup:[],
        ya:this.$request.ayar().ya,
        kid:this.$request.ayar().kid,
        sa:[], // sağlayıcı listesi
        txt:'',
        altgrup:[],
        grupid:'',//anagrupid
        cariad:'',
        newPost:
              {
                id:this.$route.params.id / 8589,
                firma : this.$request.ayar().firmaid,
                barkod :'',
                durum :0,
                cid:0, // cari id 
                sa:0,  // sağlayıcı id
                kat:0,// kategori id 
                tarih:''
              }
      };
    },
    methods: {
          yetki: function(){ 
          if (this.$helper.sayfayetki(516410)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                this.txt="where k.kid_ ="+this.kid
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
                this.txt="where s.firma ="+this.newPost.firma
            }
                if(islem){this.getPostsAsync(this.newPost.id)}
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        },
        onChange(event){
          this.progres.inprogres = true
          this.$request.get("cihazaltgrup/"+event.target.value)
           .then(res => {
             this.altgrup = res.results
             this.progres.inprogres = false
           })
        },
        cihazaltgrup(event){
          this.progres.inprogres = true
          this.$request.get("cihazaltgrup/"+event)
           .then(res => {
             this.altgrup = res.results
             this.progres.inprogres = false
           })
        },        
        cihazgrup(){
            this.$request.get("cihazgrup/"+this.newPost.firma)
            .then(res => {this.grup = res.results
             this.progres.inprogres=false
             this.progres.mesaj="Cihaz Düzenle"
            })
        },
        sagetir(){
          this.$request.get("sagetir/"+this.txt)
          .then(res => {
            if (res.status === 200){this.sa = res.results}
            else{
              this.sa.push({
                "id" : 0,
                "alias" : "Sağlayıcı yok"
              })
            }
          })
          .catch(err => this.error.push(err))
        },
        cdgetir(tables) { // bu burda numune kalsın "/define/"+this.newPost.firma+"/"+tables
          //alert(this.firma)
          this.$request.get("define/"+this.newPost.firma+"/"+tables)
          .then(data => this.cdler=data.results)
          .catch(err => this.errors.push(err))
        },
        tipsec(tip){
          this.progres.inprogres = true;
          this.cariSec = true;
          this.$request.get("caris/"+this.ya+"/"+this.kid+"/"+this.newPost.firma)
          .then(data => {this.cari = data.results;
            this.progres.inprogres = false;
          })
          .catch(err => this.errors.push(err));
        },
        calistir(kod,isim,id){
          this.newPost.carikod = kod;
          this.newPost.cariad = isim;
          this.newPost.cid =id ;
          this.selected = id;
        },
      sendNewPost() {
        if (this.newPost.barkod && this.newPost.durum && this.newPost.barkod.length>5){
          this.progres.inprogres = true
              this.$request.post("update/",this.newPost )
                .then(data => {
                    this.$swal("Cihaz Güncelleme Başarılı")
                     this.progres.inprogres = false
                    location.reload(true)
                })
                .catch(err => {this.$swal("Sistem Hatası:Cihaz Düzenlenemedi")})
        }
        else{this.$swal("Girdileri Kontrol Et")}
      },
        getPostsAsync(id) {
          this.progres.inprogres = true
              this.$request.get('cihazgenel/'+id)
                .then(data => { 
                  this.newPost.sa = data.cihaz.said;
                  this.newPost.barkod = data.cihaz.barkod;
                  this.newPost.durum = data.cihaz.cdid;
                  this.newPost.kat = data.cihaz.katid;
                  this.newPost.cid = data.cihaz.carid;
                  this.newPost.tarih = data.cihaz.yas;
                  this.grupid = data.cihaz.gid;
                  this.cariad = data.cihaz.cariad;
                  this.cihazaltgrup(data.cihaz.gid)
                  this.progres.inprogres = false

            })
            .catch(err => {{mesaj:'Sistem:Cihaz Kontrol Hatası'}})
        },
    },  
  };
</script>
<style scoped>
.highlight {
  background:lightslategray;
  color: white;
}
li{list-style: none; display:inline-block}
</style>


// WEBPACK FOOTER //
// src/views/cihaz/update.vue